var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenefitFavFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "#2E63EE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.65 35.07C13.81 29.62 5.26999 24.72 2.61999 16.73C0.529985 10.45 3.21999 2.41 10.68 1.87C17.53 1.37 19.53 5.79 19.53 5.79C19.53 5.79 21.53 1.37 28.38 1.87C35.85 2.41 38.54 10.46 36.45 16.74C33.8 24.72 25.49 29.62 19.65 35.08V35.07Z",
    stroke: "#2E63EE",
    strokeWidth: 2.11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitFavFull);
export default __webpack_public_path__ + "static/media/benefit-fav-full.ca1772fbb879e347c31712eb94edef1a.svg";
export { ForwardRef as ReactComponent };